import { HStack, Text, Icon, Hide, Heading } from '@chakra-ui/react';
import { useTranslations } from 'next-intl';
import { SuggestionsButton } from '~/components/ui/tabs/Button';
import { SuggestionsButtonList } from '~/components/ui/tabs/ButtonList';
import { SuggestionBackButton } from '~/components/ui/tabs/components/BackButton';
import { StyledTab } from '~/components/ui/tabs/StyledTab';
import { ICONS } from '~/constants/icons';
import { useFilters } from '~/hooks/useFilters';
import { useHomesStore } from '~/store/useHomesStore';
import { getFilterArrayValues } from '@habity/services';
import { FeatureButtonType, FeatureType } from '@habity/types';
import { useAgency } from '~/hooks/useAgency';
import { getFeatureButtonIcon } from '~/constants';

export const FeaturesTab = ({
  featuresFilters,
}: {
  featuresFilters: FeatureButtonType[] | null;
}) => {
  const t = useTranslations('HomesList.Tabs.Features');

  return (
    <StyledTab isDisabled={!featuresFilters}>
      <HStack>
        <Icon as={ICONS.FEATURES} /> <Text>{t('title')}</Text>
      </HStack>
    </StyledTab>
  );
};

export const FeaturesTabContent = ({
  featuresFilters,
}: {
  featuresFilters: FeatureButtonType[] | null;
}) => {
  const filters = useHomesStore((state) => state.filters);
  const { performSearch } = useFilters();
  const t = useTranslations('HomesList.Tabs.Features');
  const { agency } = useAgency();
  const { settings } = agency || {};

  const { features, is_rental_unit } = filters || {};

  const onToggleFeature = (value: FeatureType) => {
    const newFeatures = getFilterArrayValues(value, features);
    performSearch({ filters: { features: newFeatures } });
  };

  return (
    <HStack mb={1} alignItems="center" overflowX="hidden">
      <SuggestionBackButton filterKeysToRemove={['price_min', 'price_max']} />
      <SuggestionsButtonList>
        {featuresFilters &&
          featuresFilters
            .filter((f) => !f.hidden)
            .map((f, index) => (
              <SuggestionsButton
                key={index}
                icon={getFeatureButtonIcon(f.key)}
                label={f.title}
                isActive={features?.includes(f.key)}
                onClick={() => onToggleFeature(f.key)}
              />
            ))}
        {settings?.search?.showRentalUnitButton && (
          <SuggestionsButton
            key={'rental'}
            icon={ICONS.RENTAL_UNIT}
            label={t('Buttons.rentalUnit')}
            isActive={is_rental_unit || false}
            onClick={() =>
              performSearch({
                filters: {
                  is_rental_unit: is_rental_unit ? undefined : true,
                },
              })
            }
          />
        )}
      </SuggestionsButtonList>
    </HStack>
  );
};
